<template>
  <v-card class="pt-6 mx-auto text-center" flat>
    <v-list two-line>
      <v-list-item>
        <v-list-item-avatar>
          <v-img :src="getUserAvatar()"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title > {{ user.FIO }}</v-list-item-title>
          <v-list-item-subtitle><positionChip :position="{ IPOS_ID: user.IPOS_ID, IPOS_NAME: user.EMP_WTITLE }" mode="view"/></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <sys-work-area-select v-model="currDept" class="ma-3" />
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import { AUTH_SET_WA } from '@/store/actions/auth'
import { UI_INIT_APPLICATION, UI_SNACKBAR } from '@/store/actions/ui'
export default {
  name: 'sysUserCard',
  props: [],
  data: () => ({
  }),
  components: {
    SysWorkAreaSelect: () => import(/* webpackChunkName: "sysUI" */ '@/components/common/ui/selects/sysWorkAreaSelect.vue'),
    positionChip: () => import(/* webpackChunkName: "orgStructure" */'@/components/modules/org/structure/staff/positionChip.vue')
  },
  computed: {
    user: {
      get: function () {
        const profile = this.$store.getters.getProfile
        const usr = profile.userdata || {}
        return usr
      }
    },
    currDept: {
      get: function () {
        const fRet = this.$store.getters.getCurrentWA
        return fRet
      },
      set: function (val) {
        this.$store.dispatch(AUTH_SET_WA, { WA: val })
          .then(() => {
            this.$store.dispatch(UI_INIT_APPLICATION)
              .then((initData) => {
                console.log('Application reinitialization complete', initData)
                if (this.$router.currentRoute.path !== this.$store.getters.getDefaultPath) this.$router.push(this.$store.getters.getDefaultPath)
              })
          })
          .catch((err) => {
            console.log('Ошибка смены рабочей области ', err)
            this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка:' + err })
          })
      }
    }
  },
  mounted () {
    console.log('sysUserCard mounted')
  },
  methods: {
    getUserAvatar () {
      var result = '/api/user/getPhoto.php?EMP_ID=' + this.user.EMP_ID
      if (this.user.INST_ID) {
        result = result + '&INST_UUID=' + this.user.INST_UUID
      }
      return result
    }
  }
}
</script>
